import React from 'react'
import moment from 'moment'
import NavLink from '../Routes/NavLink'

import { notifications } from '../../core/controllers/Notifications'

export default class NotificationsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            list: null,
            counter: 0,
            count: 1,
            hoverOver: false
        }
    }

    componentDidMount() {
        notifications.getNotifications(this, 8);
    }

    componentDidUpdate() {}

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    tick() {
        this.setState({count: (this.state.count + 1)});
        notifications.getNotifications(this, 8);
    }

    startTimer () {
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 10000);
    }

    stopTimer () {
        clearInterval(this.timer);
    }

    componentWillUpdate(nextProps, nextState) {
        var counter = 0;
        if(nextState.list != null) {
            for(var i = 0; i < nextState.list.length; i++) {
                if(nextState.list[i].seen_at == 0) {
                    counter++;
                }
            }
        }
        if(nextState.hoverOver && counter != 0) {
            counter--;
            nextState.hoverOver = false;
        } 

        nextState.counter = counter;
        if(nextState.count == 1) {
            this.startTimer();
        }
    }

    seenAt(e) {
        const jTarget = jQuery(e.target);
        if(jTarget.hasClass('unseen')) {
            const notification_id = jTarget.attr('id');
            notifications.seen(notification_id);
            jTarget.removeClass('unseen');

            var counter = this.state.counter;
            counter--;

            this.setState({
                counter: counter,
                hoverOver: true
            });
        }
    }

    render(){
        const notificationsList = this.state.list;
        const counter = this.state.counter;
        const self = this;
        return (
            <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                    <div class="bell">
                        <i class="icon-notification"></i>
                        {counter > 0 && (
                            <span class="notification">{counter}</span>
                        )}
                    </div>
                </a>
                <ul class="dropdown-menu">
                    {notificationsList != null && notificationsList.length > 0 ? (
                        notificationsList.map(function(notification, index){
                            const title = notification.title;
                            const message = notification.message;
                            const created = notification.created_at;
                            const id = notification.notifications_id;

                            var hasSeen = '';
                            if(notification.seen_at == 0) {
                                hasSeen = 'unseen';
                            }

                            return (
                                <li key={index}>
                                    <span id={id} onMouseOver={self.seenAt.bind(self)} class={hasSeen + " notification-container"}>{title}<br/><small>{moment.utc(created).local().format('MMMM Do YYYY, h:mm a')}</small></span>
                                </li>
                            )
                        })
                    ) : (
                            <li>
                                <span class="notification-container">No updates!</span>
                            </li>
                        )
                    }
                    <li>
                        <NavLink to={"/activity"}>
                            View Activity Log
                        </NavLink>
                    </li>
                </ul>
            </li>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Notifications/NotificationsList.jsx